<template>
  <div class="pos intro-y grid grid-cols-12 gap-5 mt-5">
    <div class="col-span-12">
      <div class="intro-y box p-5">
        <div class="mt-3">
          <label for="street" class="form-label w-full flex flex-col sm:flex-row">
            {{ $t('address.street') }}
          </label>
          <input id="street" v-model.trim="validate.street.$model" type="text" name="street" class="
              intro-y
              form-control
              py-3
              px-4
              box
              pr-10
              placeholder-theme-13
            " :class="{ 'border-theme-6': validate.street.$error }" placeholder="Popradska"
            @input="$emit('update:address', getAddressData())" />
        </div>
        <div class="mt-3">
          <label for="streetNumber" class="form-label w-full flex flex-col sm:flex-row">
            {{ $t('address.streetNumber') }}
          </label>
          <input id="streetNumber" v-model.trim="validate.streetNumber.$model" type="text" name="streetNumber" class="
              intro-y
              form-control
              py-3
              px-4
              box
              pr-10
              placeholder-theme-13
            " :class="{ 'border-theme-6': validate.streetNumber.$error }" placeholder="29/A"
            @input="$emit('update:address', getAddressData())" />
        </div>
        <div class="mt-3">
          <label for="city" class="form-label w-full flex flex-col sm:flex-row">
            {{ $t('address.city') }}
          </label>
          <input id="city" v-model.trim="validate.city.$model" type="text" name="city" class="
              intro-y
              form-control
              py-3
              px-4
              box
              pr-10
              placeholder-theme-13
            " :class="{ 'border-theme-6': validate.city.$error }" placeholder="Poprad"
            @input="$emit('update:address', getAddressData())" />
        </div>
        <div class="mt-3">
          <label for="zip" class="form-label w-full flex flex-col sm:flex-row">
            {{ $t('address.zip') }}
          </label>
          <input id="zip" v-model.trim="validate.zip.$model" type="text" name="zip" class="
              intro-y
              form-control
              py-3
              px-4
              box
              pr-10
              placeholder-theme-13
            " :class="{ 'border-theme-6': validate.zip.$error }" placeholder="05801"
            @input="$emit('update:address', getAddressData())" />
        </div>
        <div class="mt-3">
          <label for="state" class="form-label w-full flex flex-col sm:flex-row">
            {{ $t('address.country') }}
          </label>
          <TomSelect v-model="validate.state.$model" :options="{
            create: false,
            placeholder: $t('address.countrySelect')
          }" class="w-full">
            <option value="SVK">Slovensko</option>
          </TomSelect>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, computed, ref } from 'vue'
import { helpers } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'

export default defineComponent({
  props: {
    address: {
      type: Object,
      default: () => {
        return {
          street: '',
          streetNumber: '',
          city: '',
          zip: '',
          state: 'SVK'
        }
      }
    }
  },

  methods: {
    getAddressData() {
      return this.formData
    }
  },

  emits: ['update:address'],

  setup(props, { emit }) {
    const zipValidator = helpers.regex(/^([0-9 ]{5,})?$/)
    const formData = ref(props.address)
    const rules = {
      street: {},
      streetNumber: {},
      city: {},
      zip: {
        zipValidator
      },
      state: {}
    }
    const validate = useVuelidate(rules, formData)

    const componentValue = computed({
      get: () => props.address,
      set: () => emit('update:address', validate)
    })

    return {
      validate,
      formData,
      componentValue
    }
  }
})
</script>
